import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EventListControlsComponent } from './event-list-controls.component'
import { DateBarModule } from '../../../date-filters/date-bar/date-bar.module'
import { DatePickerModule } from '../../../date-filters/date-picker/date-picker.module'
import { SharedModule } from '../../../../shared/shared.module'
import { FiltersModule } from '../../../filters/filters.module'
import { ToggleModule } from '../../../toggle/toggle.module'

@NgModule({
  imports: [CommonModule, SharedModule, DateBarModule, DatePickerModule, FiltersModule, ToggleModule],
  declarations: [EventListControlsComponent],
  exports: [EventListControlsComponent]
})
export class EventListControlsModule {}
